<template lang="html">
  <td class="table-info-cell text-xs-center">
    <booking-request-icon
      v-if="bookingRequest"
      class="info-icon"/>
    <booked-icon
      v-if="booked"
      class="info-icon"/>
    <date-approaching-icon
      v-if="dateApproaching"
      class="info-icon"/>
  </td>
</template>

<script>
import BookingRequestInfoIcon from './BookingRequestInfoIcon'
import BookedInfoIcon from './BookedInfoIcon'
import DateApproachingInfoIcon from './DateApproachingInfoIcon'
export default {
  components: {
    'booking-request-icon': BookingRequestInfoIcon,
    'booked-icon': BookedInfoIcon,
    'date-approaching-icon': DateApproachingInfoIcon
  },
  props: {
    bookingRequest: {
      type: Boolean,
      required: false,
      default: false
    },
    booked: {
      type: Boolean,
      required: false,
      default: false
    },
    dateApproaching: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: () => ({}),

}
</script>

<style lang="css" scoped>
</style>
